// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".catalog>.title[data-v-1271f111]{font-size:20px;font-weight:lighter;padding:0 10px}.catalog .offers-block[data-v-1271f111]{padding-bottom:40px;padding-top:20px;width:100%}.catalog .offers-block[data-v-1271f111]:nth-child(2n){background-color:#f8f8f8}.catalog .offers-container[data-v-1271f111]{display:flex;flex-wrap:wrap;justify-content:space-around}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
